import { Provider } from 'near-api-js/lib/providers';
import { Jumbo } from '../../jumbo';
import { RefFinance } from '../../refFinance';
import { SpinFinanceMarket } from '../../spin';
import { TonicFoundationMarket } from '../../tonic';
import { Route } from '../route/types';

const getAllAmms = async (provider: Provider) => {
  const refPools = await RefFinance.loadPools({ provider });
  const jumboPools = await Jumbo.loadPools({ provider });

  const spinMarkets = await SpinFinanceMarket.loadMarkets({ provider });
  const tonicMarkets = await TonicFoundationMarket.loadMarkets({ provider });

  const amms = [...refPools, ...jumboPools, ...spinMarkets, ...tonicMarkets];

  return amms;
};

async function updateRoutesPools(provider: Provider, routes: Route[]) {
  const promisesMap = new Map();

  routes.forEach((route) => {
    route.forEach(({ amm }) => {
      promisesMap.set(
        `${amm.label}-${amm.id}`,
        amm.getPromiseForUpdate({ provider })
      );
    });
  });

  const promises = Array.from(promisesMap.values());
  // console.log('promises number', promises.length);
  await Promise.all(promises);
}

export { getAllAmms, updateRoutesPools };
